module.exports = __webpack_public_path__ + "img/dy.0dbe471e.jpg";